import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import customerReducer from "./customerReducer";
import apiReducer from "./apiReducer";
import Contact from "./Contact";

import Auth from "./Auth";
import SystemDocuments from "./SystemDocuments";
import Subscriptions from "./Subscriptions";
import userReducer from "./reviewer_reducers/userReducer";
import TaskReducer from "./reviewer_reducers/TaskReducer";
import employerReducer from "./reviewer_reducers/employerReducer";
import scheduleReducer from "./reviewer_reducers/scheduleReducer";
import shiftReducer from "./reviewer_reducers/shiftReducer";
import employeeUserReducer from "./reviewer_reducers/employeeUserReducer";
import payStubsReducer from "./reviewer_reducers/payStubsReducer";
import createReviewerReducer from "./createReviewerReducer";
import dbReducers from "./dbReducers";
import RewardReducer from "./rewardReducer";
import termsPrivacyReducer from "./termsPrivacyReducer";
import couponsReducer from "./couponsReducer";

export default history =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    contacts: Contact,
    auth: Auth,
    customerReducer,
    SystemDocuments,
    Subscriptions,
    apiReducer,
    userReducer,
    TaskReducer,
    employerReducer,
    scheduleReducer,
    shiftReducer,
    employeeUserReducer,
    payStubsReducer,
    createReviewerReducer,
    dbReducers,
    RewardReducer,
    termsPrivacyReducer,
    couponsReducer
  });
